import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currencyList: [],
};

const currencyListSlice = createSlice({
  name: "currencyList",
  initialState,
  reducers: {
    updateCurrencyList: (state, action) => {
      const index = state.currencyList.findIndex(
        (item) => item.country === action.payload.country
      );
      if (index !== -1) {
        state.currencyList[index] = action.payload;
      } else {
        state.currencyList.push(action.payload);
      }
    },
  },
});

export const { updateCurrencyList } = currencyListSlice.actions;

export default currencyListSlice.reducer;
